import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Page/page';
import { css } from '@patternfly/react-styles';
import { formatBreakpointMods } from '../../helpers/util';
export var PageHeaderToolsGroup = function PageHeaderToolsGroup(_a) {
  var children = _a.children,
      className = _a.className,
      visibility = _a.visibility,
      props = __rest(_a, ["children", "className", "visibility"]);

  return React.createElement("div", Object.assign({
    className: css(styles.pageHeaderToolsGroup, formatBreakpointMods(visibility, styles), className)
  }, props), children);
};